import { render } from "./EnbCateg.vue?vue&type=template&id=bfe5f364&scoped=true"
import script from "./EnbCateg.vue?vue&type=script&lang=js"
export * from "./EnbCateg.vue?vue&type=script&lang=js"

import "./EnbCateg.vue?vue&type=style&index=0&id=bfe5f364&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe5f364"]])

export default __exports__